import { render, staticRenderFns } from "./EconomyOrder.vue?vue&type=template&id=39c44d8c&scoped=true&"
import script from "./EconomyOrder.vue?vue&type=script&lang=js&"
export * from "./EconomyOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c44d8c",
  null
  
)

export default component.exports